import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import { get, isEmpty } from 'lodash';
import Locations from './components/Locations';
import GMap from './components/Map';
import { formattedAddress } from '../../lib/helper';
import {
  locationDetails,
  modeOfOrder,
  reloadStore,
  deliveryDetails,
  hideOrderTypePopup,
  setReOrderRedirection,
} from '../dashboard/actions';
import {
  getSelectedRestaurantLocationDetails,
  isDataNameFilterForDining,
  getModeOfOrder,
  getDeliveryDetails,
  getPreviousModeOfOrder,
  getUserLocation,
  isOrderTypeOnCart,
  getOrderTypePopUp,
  getUserSelectedLocation,
  getUserLocationSet,
  dashboardData,
} from '../dashboard/reducer';
import DeliveryAddressForm from '../dashboard/components/orderType/DeliveryAddressForm';
import { LocationLoader } from '../common/Loading';
import {
  SearchAvailableAddress,
  FilterAddress,
} from '../../api/searchForAddress';
import { DINING_OPTIONS, TYPE_DELIVERY } from '../../util/Constants';
import { getTokenId, getJWT, getUserDetails, getUserId } from '../../redux/reducers/authenticationReducers';
import UserLocation from './components/UserLocation';
import { ToastContainer, ToastMessageFactory } from '../../lib';
import { FormattedMessage } from 'react-intl';
import defaultMsg from '../../translations/lang/en-US.json';

class RestaurantLocations extends React.Component {
  constructor(props) {
    super(props);
    this.handleOrderType = this.handleOrderType.bind(this);
    this.getAddresses = this.getAddresses.bind(this);
    this.hideLocation = this.hideLocation.bind(this);
    this.setRestaurantDetails = this.setRestaurantDetails.bind(this);
    this.orderNow = this.orderNow.bind(this);
    this.getSelectedRestaurant = this.getSelectedRestaurant.bind(this);
    this.getActiveModeOfOrder = this.getActiveModeOfOrder.bind(this);
    this.getActiveLocations = this.getActiveLocations.bind(this);
    this.cancelOrderType = this.cancelOrderType.bind(this);
    this.onHandleLocation = this.onHandleLocation.bind(this);
    this.cancel = this.cancel.bind(this);

    const modeOfOrder = this.getActiveModeOfOrder();
    this.state = {
      searchingLocation: false,
      userSelectedLocation: this.getSelectedRestaurant(),
      modeOfOrder: modeOfOrder,
      retaurantDeliveryDetails: false,
      showLocation: modeOfOrder === TYPE_DELIVERY ? false : true,
      deliveryAddress: get(
        this.props,
        'deliveryInformation.deliveryAddress',
        false
      ),
      source: get(this.props, 'deliveryInformation.source', false),
      noDeliveryToUserLocation: false,
      isRestaurantAvailable: false,
    };
  }

  componentDidMount() {
    let previousRoute = this.props.dashboardData.previousRoute
      ? this.props.dashboardData.previousRoute
      : '';
    if (
      this.props.userLocation.availableRestaurant &&
      this.props.userLocation.availableRestaurant.length > 0 &&
      previousRoute === localStorage.getItem('lavutoGoName')
    ) {
      this.setState({ isRestaurantAvailable: true });
    }
  }

  componentWillMount() {
    if (
      this.props.deliveryInformation.deliveryAddress &&
      this.props.deliveryInformation.source &&
      this.state.modeOfOrder === TYPE_DELIVERY &&
      isEmpty(this.props.userId)
    ) {
      this.getAddresses(
        this.props.deliveryInformation.deliveryAddress,
        this.props.deliveryInformation.source
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      modeOfOrder: nextProps.modeOfOrder,
      showLocation: nextProps.modeOfOrder === TYPE_DELIVERY ? false : true,
    });
  }

  cancelOrderType() {
    this.setState({
      modeOfOrder: 0,
      showLocation: true,
      source: {},
    });
  }

  getActiveModeOfOrder() {
    if (this.state) {
      return this.state.modeOfOrder || this.props.modeOfOrder;
    } else {
      return this.props.modeOfOrder || 0;
    }
  }

  setRestaurantDetails(data) {
    const { id, title, delivery_fees, delivery_time, delivery_distance } = data;
    const restaurantDetails = Object.assign({}, data, {
      selectedLocationAddressId: id,
      selectedLocationAddress: formattedAddress(data),
      restuarantName: title,
      delivery_fees,
      deliveryTime: delivery_time,
      distance: delivery_distance,
    });
    this.props.actions.locationDetails(restaurantDetails);
  }

  handleOrderType(data, type) {
    this.setState({
      userSelectedLocation: data,
      modeOfOrder: type,
      showLocation: type === TYPE_DELIVERY ? false : true,
      retaurantDeliveryDetails: false,
      noDeliveryToUserLocation: false,
    });

    if (type !== TYPE_DELIVERY) {
      this.props.actions.modeOfOrder(type);
      this.setRestaurantDetails(data);
      if (this.props.dashboardData.isReOrderRedirection === true) {
        this.props.actions.setReOrderRedirection(false);
        browserHistory.push('/' + data.lavu_togo_name + '/checkout');
      } else if (
        !this.props.isDataNameFilterForDining &&
        !this.props.isOrderTypeOnCart
      ) {
        browserHistory.push('/' + data.lavu_togo_name);
        this.props.actions.reloadStore(true);
      }
    }
  }

  getAddresses(deliveryAddress, source) {
    if (deliveryAddress.length < 3) {
      this.refs.otp_container.error('Please enter your complete address');
    } else {
      const getSource = (deliveryAddress, source) => {
        return Object.assign({}, source, {
          deliveryAddress: deliveryAddress,
          collapsed: false,
          shortAddress: true,
        });
      };
      this.setState({
        searchingLocation: true,
        showLocation: false,
        source: getSource(deliveryAddress, source),
        retaurantDeliveryDetails: false,
        noDeliveryToUserLocation: false,
      });

      const { tokenId, jwt, isDataNameFilterForDining } = this.props;
      const dataname = get(this.state, 'userSelectedLocation.dataname', '');
      const rname = get(this.state, 'userSelectedLocation.lavu_togo_name', '');

      SearchAvailableAddress({
        streetAddress: deliveryAddress,
        dataname: dataname,
        diningOption: DINING_OPTIONS['Delivery'],
        jwt,
        tokenId,
        rname,
      }).then(searchResult => {
        const { foundAddresses } = FilterAddress({
          foundAddresses: searchResult.data.DataResponse.sourceaddress,
          filterWithDataName: isDataNameFilterForDining,
          dataName: dataname,
        });
        const isDeliverable =
          typeof foundAddresses === 'object' &&
          foundAddresses.length > 0 &&
          foundAddresses;
        this.setState({
          retaurantDeliveryDetails: isDeliverable ? foundAddresses[0] : false,
          showLocation: true,
          searchingLocation: false,
          deliveryAddress: deliveryAddress,
          noDeliveryToUserLocation: !isDeliverable ? true : false,
        });
      });
    }
  }

  hideLocation() {
    this.setState({
      searchingLocation: false,
      showLocation: false,
      deliveryAddress: false,
      source: {},
    });
  }

  orderNow() {
    this.props.actions.modeOfOrder(TYPE_DELIVERY);
    const deliveryDetails = Object.assign(
      {},
      this.getSelectedRestaurant(),
      this.state.retaurantDeliveryDetails
    );
    this.setRestaurantDetails(deliveryDetails);
    this.props.actions.deliveryDetails({
      deliveryAddress: this.state.deliveryAddress,
      source: this.state.source,
    });
    if (this.props.dashboardData.isReOrderRedirection === true) {
      this.props.actions.setReOrderRedirection(false);
      browserHistory.push(
        '/' + this.state.retaurantDeliveryDetails.lavu_togo_name + '/checkout'
      );
    } else if (
      !this.props.isDataNameFilterForDining &&
      !this.props.isOrderTypeOnCart
    ) {
      browserHistory.push(
        '/' + this.state.retaurantDeliveryDetails.lavu_togo_name
      );
      this.props.actions.reloadStore(true);
    }
  }

  getSelectedRestaurant() {
    if (Object.keys(this.props.selectedRestuarant).length) {
      return this.props.selectedRestuarant;
    } else {
      return this.state ? this.state.userSelectedLocation : {};
    }
  }

  getActiveLocations() {
    if (this.props.isDataNameFilterForDining || this.props.isOrderTypeOnCart) {
      return [this.props.selectedRestuarant];
    } else {
      if (
        this.props.userLocation.availableRestaurant &&
        this.props.locations.length > 0
      ) {
        const locations = [];
        const availableRestaurantLength = get(
          this,
          'props.userLocation.availableRestaurant',
          []
        ).length;
        const locationsLength = get(this, 'props.locations', []).length;

        for (let i = 0; i < availableRestaurantLength; i++) {
          for (let j = 0; j < locationsLength; j++) {
            if (
              this.props.userLocation.availableRestaurant[i].dataname ===
              this.props.locations[j].dataname
            ) {
              locations.push(this.props.locations[j]);
            }
          }
        }
        return locations;
      } else {
        return !this.props.userLocation.availableRestaurant &&
          this.props.locations.length
          ? this.props.locations
          : [];
      }
    }
  }

  cancel() {
    this.setState({ isRestaurantAvailable: false });
    if (!this.props.isOrderTypeOnCart) {
      this.props.actions.modeOfOrder(this.props.previousModeOfOrder);
    } else {
      this.props.actions.hideOrderTypePopup();
    }
  }

  onHandleLocation(locationAvailability) {
    this.setState({ isRestaurantAvailable: locationAvailability });
  }

  render() {
    const locations = this.getActiveLocations();
    const containerClasses =
      this.state.modeOfOrder === TYPE_DELIVERY
        ? 'col-lg-12 col-md-12 col-sm-12 col-xs-12'
        : 'col-lg-7 col-md-7 col-sm-7 col-xs-12';
    let dineInOption = this.props.dashboardData.merchantDetails[
      'ltg_dine_in_option_2'
    ];
    let deliveryPresent = dineInOption.indexOf('Delivery');
    return this.state.isRestaurantAvailable === false &&
      this.props.locations.length > 0 &&
      this.props.orderPopUp === false &&
      !this.props.isUserLocationSet &&
      this.props.tokenId !== false &&
      (this.props.showMultipleLocations === '0' && deliveryPresent !== -1) ? (
      <UserLocation
        onSelectLocation={this.onHandleLocation}
        rname={this.props.rname}
        isAuthSet={this.props.auth}
      />
    ) : this.props.tokenId !== false ? (
      <div>
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="otp_container"
          className="toast-top-right"
        />
        <Modal show={this.props.show} dialogClassName="modal-lg">
          <Modal.Header>
            <h4 className="modal-title">
              {this.props.showMultipleLocations === '1' ? (
                <FormattedMessage
                  id="selectOrderType"
                  defaultMessage={defaultMsg.selectOrderType}
                />
              ) : (
                <FormattedMessage
                  id="selectLocation"
                  defaultMessage={defaultMsg.selectLocation}
                />
              )}
              {this.props.showMultipleLocations === '0' &&
              deliveryPresent !== -1 &&
              this.props.dashboardData.reOrderStatPopUp === false ? (
                <span
                  className="fa fa-times pull-right cursonPointer"
                  onClick={this.cancel}
                />
              ) : null}
            </h4>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              {this.state.modeOfOrder !== TYPE_DELIVERY ? (
                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                  {locations.length ? (
                    <Locations
                      handleOrderType={(data, type) =>
                        this.handleOrderType(data, type)
                      }
                      list={locations}
                      actions={this.props.actions}
                      modeOfOrder={this.getActiveModeOfOrder()}
                      activeRestaurantLocation={this.state.userSelectedLocation}
                      showMultipleLocations={this.props.showMultipleLocations}
                      locationName={this.props.rname}
                    />
                  ) : (
                    <div className="text-center"> 
                      <FormattedMessage
                        id="noResultsFound"
                        defaultMessage={defaultMsg.noResultsFound}
                      />
                    </div>
                  )}
                </div>
              ) : null}
              <div className={containerClasses}>
                {this.state.modeOfOrder === TYPE_DELIVERY ? (
                  <DeliveryAddressForm
                    getAddresses={(address, source) =>
                      this.getAddresses(address, source)
                    }
                    hideLocation={this.hideLocation}
                    deliveryInformation={this.state.retaurantDeliveryDetails}
                    source={
                      !isEmpty(this.props.userId) ? {} : this.state.source
                    }
                    noDeliveryToUserLocation={
                      this.state.noDeliveryToUserLocation
                    }
                    orderNow={() => this.orderNow()}
                    cancel={this.cancelOrderType}
                    targettingOneLocation={this.props.isDataNameFilterForDining}
                    searchingLocation={this.state.searchingLocation}
                  />
                ) : null}
                {this.state.searchingLocation === true ? (
                  <LocationLoader />
                ) : null}
                {this.state.showLocation ||
                (isEmpty(this.props.userId) &&
                  !isEmpty(this.state.source) &&
                  this.state.searchingLocation === false) ? (
                  <GMap
                    start={this.state.retaurantDeliveryDetails}
                    end={
                      this.state.modeOfOrder === TYPE_DELIVERY
                        ? this.state.deliveryAddress
                        : false
                    }
                    maplocations={this.props.locations}
                  />
                ) : null}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    ) : null;
  }
}

const mapStateToProps = state => ({
  selectedRestuarant: getSelectedRestaurantLocationDetails(state),
  tokenId: getTokenId(state),
  jwt: getJWT(state),
  auth: getUserDetails(state),
  userId: getUserId(state),
  isDataNameFilterForDining: isDataNameFilterForDining(state),
  modeOfOrder: getModeOfOrder(state),
  deliveryInformation: getDeliveryDetails(state),
  previousModeOfOrder: getPreviousModeOfOrder(state),
  userLocation: getUserLocation(state),
  isOrderTypeOnCart: isOrderTypeOnCart(state),
  orderPopUp: getOrderTypePopUp(state),
  userSelectedLocation: getUserSelectedLocation(state),
  isUserLocationSet: getUserLocationSet(state),
  dashboardData: dashboardData(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      locationDetails,
      modeOfOrder,
      reloadStore,
      deliveryDetails,
      hideOrderTypePopup,
      setReOrderRedirection,
    },
    dispatch
  ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RestaurantLocations);



// WEBPACK FOOTER //
// ./src/views/orderType/RestaurantLocations.jsx